import {Mapper} from '@s-ui/domain'

export class SeoLandingInstantOfferMetaInformationMapper extends Mapper {
  constructor({config, seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper}) {
    super()

    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
  }

  _buildCanonical = () => {
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const {LANDING_INSTANT_OFFER_PATTERN} = this._config.get('page')

    return `${protocol}${host}${LANDING_INSTANT_OFFER_PATTERN}`
  }

  async map({culture}) {
    const {landingInstantOffer: landingInstantOfferConfig} = this._config.get('seo')
    const {
      H1,
      // META_DESCRIPTION, // To add next sprint
      META_ROBOTS,
      TITLE
    } = landingInstantOfferConfig[culture]

    const canonical = this._buildCanonical()

    const parsedTitle = this._seoLiteralMapper.setText({text: TITLE}).map()

    const parsedH1 = this._seoLiteralMapper.setText({text: H1}).map()

    // To add next sprint
    // const parsedDescription = this._seoLiteralMapper
    //   .setText({text: META_DESCRIPTION})
    //   .map()

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(parsedTitle)
      // .description(parsedDescription) // To add next sprint
      .robots(META_ROBOTS)
      .canonical(canonical)
      .setOpenGraphData({
        title: parsedTitle,
        url: canonical
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      h1: parsedH1,
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
